import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { keyframes } from "@mui/material/styles";

const statFadeUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Compact "waiting for" duration, matching the existing "42m"/"3h" placeholder style.
// null/undefined (no unattended conversations yet) renders as "—".
function formatWaitingSince(oldestWaitingAt) {
  if (!oldestWaitingAt) return "—";
  const diffMs = Date.now() - new Date(oldestWaitingAt).getTime();
  if (diffMs <= 0) return "0m";
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
}

function UnattendedCard({ count, oldestWaitingAt, loading }) {
  const theme = useTheme();
  const accent = "#f59e0b";
  const dividerColor = theme.palette.divider;

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${dividerColor}`,
        borderRadius: "24px",
        p: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 1.75,
        animation: `${statFadeUp} 0.45s ease both`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: accent }} />
        <Typography sx={{ fontSize: "1.0625rem", fontWeight: 600 }}>Unattended</Typography>
      </Box>

      <Typography sx={{ fontSize: "2.5rem", fontWeight: 700, lineHeight: 1.2 }}>
        {loading && count == null ? "—" : count ?? 0}
      </Typography>

      <Typography sx={{ fontSize: "0.9375rem", color: "text.secondary" }}>conversations waiting on a reply</Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 3, mt: 0.5, pt: 1.75, borderTop: `1px solid ${dividerColor}` }}>
        <Box>
          <Typography sx={{ fontSize: "0.8125rem", color: "text.secondary" }}>Oldest waiting</Typography>
          <Typography sx={{ fontSize: "1.0625rem", fontWeight: 700, mt: 0.25 }}>
            {loading && count == null ? "—" : formatWaitingSince(oldestWaitingAt)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default UnattendedCard;
